<template>
  <ModuleContainer>
    <slot />
  </ModuleContainer>
</template>

<script>
// import mapboxgl from '@plugins/mapbox-gl'
import ModuleMixin from "@/components/Map/ModuleMixin";
import { ButtonGroupControl } from "@/components/Map/leaflet/ButtonGroupControl";

export default {
  mixins: [ModuleMixin],

  data() {
    return {
      center: {
        lat: 0,
        lng: 0
      },
      zoom: 0
    };
  },

  methods: {
    onInit() {
      this.center = this.map.getCenter();
      this.zoom = this.map.getZoom();

      this.addControl(
        ButtonGroupControl.create([
          {
            title: "Go to Home",
            icon: "home",
            onClick: () => {
              this.map.setView(this.center, this.zoom);
            }
          }
        ])
      );
    }
  }
};
</script>
